var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('section',{staticClass:"el-container"},[_c('main',{staticClass:"el-main defaultnew"},[_c('web-header'),(_vm.isRouterAlive)?_c('router-view'):_vm._e(),_c('web-footer',{attrs:{"marginTop":_vm.footerTop}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }